import { CONFIG } from "@shared/config";
import type { StationDatabase } from "@shared/config/types";
import { useUIStore } from "@shared/store/ui";
import { ResultAsync } from "neverthrow";
import logger from "@shared/utils/logger";

const {
  application: {
    initialization: { stationDatabasesPerCountry },
  },
} = CONFIG;

export const getDatabaseByCountry = async (): Promise<
  StationDatabase | undefined
> => {
  const uiStore = useUIStore();

  const { fetchUserLocation, countryDatabase } = uiStore;

  const stationDatabase = countryDatabase
    ? stationDatabasesPerCountry?.[countryDatabase]
    : undefined;

  if (stationDatabase) {
    return stationDatabase;
  }

  const safeFetchUserLocation = ResultAsync.fromThrowable(fetchUserLocation);

  const responseResult = await safeFetchUserLocation();

  if (responseResult.isErr()) {
    logger.error("Failed to fetch user location");
    return;
  }

  // TODO: Value can be `undefined`, which can not be destructured.
  if (!responseResult.value) {
    return;
  }

  const { country } = responseResult.value;

  if (!country) return;

  return stationDatabasesPerCountry?.[country];
};
